import { render, staticRenderFns } from "./r-tooltip.vue?vue&type=template&id=1fefa06c"
import script from "./r-tooltip.vue?vue&type=script&lang=js"
export * from "./r-tooltip.vue?vue&type=script&lang=js"
import style0 from "./r-tooltip.vue?vue&type=style&index=0&id=1fefa06c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports